import { FAQView } from '@features/faq/views/faq.view';
import { Loader } from '@features/_shared/components/Loader';
import React from 'react';
import './App.css';

interface IAppProps {
    isLoading?: boolean;
}

export class App extends React.Component<IAppProps> {
    render() {
        return (
            <>
                <Loader isLoading={!!this.props.isLoading} />
                <div className='app-container d-flex flex-column justify-content-between'>
                    <div>
                        <FAQView />
                    </div>
                </div>
            </>
        );
    }
}

export default App;
